import lazyGettext from 'js-utils/lazy-gettext';
import {
    BRANDED_PAGES,
    CUSTOMER_SUPPORT,
    CUSTOMIZABLE_CHECKOUT_FORMS,
    DETAIL_SALES_ANALYTICS,
    LISTING_PARTNER_SITES,
    ONSITE_RENTAL_SUPPORT,
    TICKET_SALES_SITE,
    TICKET_TYPES,
    TR_ESSENTIALS,
} from '../../constants/signupFeatures';
import {
    PRICE_PER_FREE_TICKET,
    PRODUCT_TRAINING,
} from '../../constants/featuresComparison';
import {
    CONTACT_US_TEXT,
    DEFAULT_PACKAGE_TYPES,
    DEFAULT_PACKAGES,
    FINE_PRINT_WITH_FIXED_FEE,
    GET_STARTED_TEXT,
    PACKAGE_DESCRIPTIONS,
    PACKAGE_THREE,
} from '../../constants/main';
import {
    STYLE_FILL,
    STYLE_NEUTRAL,
} from 'eventbrite_design_system/button/constants';

export default {
    packages: DEFAULT_PACKAGES,
    packageTypes: DEFAULT_PACKAGE_TYPES,
    primaryHeading: lazyGettext("Find the solution that's right for you"),
    secondaryHeading: lazyGettext(
        'Avoid ticketing fees by passing them to attendees',
    ),
    featureDescriptions: PACKAGE_DESCRIPTIONS,
    feeBreakdownOverride: {
        [PACKAGE_THREE]: {
            formattedFee: lazyGettext('Custom'),
        },
    },
    extraMainFeatures: [
        CUSTOMER_SUPPORT,
        TICKET_TYPES,
        TR_ESSENTIALS,
        LISTING_PARTNER_SITES,
        TICKET_SALES_SITE,
        CUSTOMIZABLE_CHECKOUT_FORMS,
        DETAIL_SALES_ANALYTICS,
        ONSITE_RENTAL_SUPPORT,
        BRANDED_PAGES,
        PRODUCT_TRAINING,
    ],
    CTAs: [GET_STARTED_TEXT, GET_STARTED_TEXT, CONTACT_US_TEXT],
    CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
    finePrint: FINE_PRINT_WITH_FIXED_FEE,
    pricePerFreeTicket: PRICE_PER_FREE_TICKET,
    shouldShowAnnualFee: false,
};
